import { render, staticRenderFns } from "./project_visibility_icon.vue?vue&type=template&id=4bc73c66"
import script from "./project_visibility_icon.vue?vue&type=script&lang=js"
export * from "./project_visibility_icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports